<template>
    <div class="good-list-container">
        <!-- 为什么选择我们 - 统一说明区域 -->
        <div class="why-choose-us-section">
            <div class="why-choose-us-container">
                <h3 class="why-choose-us-title">为什么选择我们？</h3>
                <div class="why-choose-us-content">
                    <div class="feature-item">
                        <el-icon color="#409efc"><Promotion /></el-icon>
                        <span class="feature-text"
                            ><strong>权威报告</strong>：提供全球高校广泛认可的Tūrnitin报告。</span
                        >
                    </div>
                    <div class="feature-item">
                        <el-icon color="#409efc"><Promotion /></el-icon>
                        <span class="feature-text"
                            ><strong>双重保障</strong
                            >：每次检测都同时提供查重和AI检测双报告，全面评估文稿质量。</span
                        >
                    </div>
                    <div class="feature-item">
                        <el-icon color="#409efc"><Promotion /></el-icon>
                        <span class="feature-text"
                            ><strong>精准定位</strong>：独家提供AI内容高亮服务，修改不再盲目。</span
                        >
                    </div>
                    <div class="feature-item">
                        <el-icon color="#409efc"><Promotion /></el-icon>
                        <span class="feature-text"
                            ><strong>安全保障</strong
                            >：我们承诺绝不收录您的任何提交文档，保障您的学术成果安全。</span
                        >
                    </div>
                </div>
            </div>
        </div>

        <div class="goods-list">
            <el-card class="good-detail" shadow="never">
                <h2 class="good-detail-title">1次</h2>
                <p class="good-detail-info">
                    <span class="currency-type">¥ </span>
                    <span class="goods-price">{{ goodListPrice[0] }}</span>
                </p>
                <el-button
                    class="buy-now"
                    round
                    style="width: 100%; font-size: 20px"
                    type="danger"
                    @click="doRecharge(300001, goodListPrice[0], '套餐一_300001')"
                >
                    立即购买
                </el-button>
                <ul class="good-detail-introduce-list">
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin查重报告
                    </li>
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin AI检测报告
                    </li>
                    <li class="good-detail-introduce-bold">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        降AI充值会员免费获取1次检测报告
                    </li>
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        快速、精准、适合单篇文稿
                    </li>
                </ul>
            </el-card>
            <el-card class="good-detail" shadow="never">
                <h2 class="good-detail-title">3次</h2>
                <p class="good-detail-info">
                    <span class="currency-type">¥ </span>
                    <span class="goods-price">{{ goodListPrice[1] }}</span>
                </p>
                <el-button
                    class="buy-now"
                    round
                    style="width: 100%; font-size: 20px"
                    type="danger"
                    @click="doRecharge(300002, goodListPrice[1], '套餐二_300002')"
                >
                    立即购买
                </el-button>
                <ul class="good-detail-introduce-list">
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin查重报告
                    </li>
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin AI检测报告
                    </li>
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        更活力便、满足短期多稿需求
                    </li>
                </ul>
            </el-card>
            <el-card class="good-detail" shadow="never">
                <h2 class="good-detail-title">5次</h2>
                <p class="good-detail-info">
                    <span class="currency-type">¥ </span>
                    <span class="goods-price">{{ goodListPrice[2] }}</span>
                </p>
                <el-button
                    class="buy-now"
                    round
                    style="width: 100%; font-size: 20px"
                    type="danger"
                    @click="doRecharge(300003, goodListPrice[2], '套餐三_300003')"
                >
                    立即购买
                </el-button>
                <ul class="good-detail-introduce-list">
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin查重报告
                    </li>
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin AI检测报告
                    </li>
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        经济实惠，应对一学期作业
                    </li>
                </ul>
            </el-card>
            <el-card class="good-detail" shadow="never">
                <h2 class="good-detail-title">10次</h2>
                <p class="good-detail-info">
                    <span class="currency-type">¥ </span>
                    <span class="goods-price">{{ goodListPrice[3] }}</span>
                </p>
                <el-button
                    class="buy-now"
                    round
                    style="width: 100%; font-size: 20px"
                    type="danger"
                    @click="doRecharge(300004, goodListPrice[3], '套餐四_300004')"
                >
                    立即购买
                </el-button>
                <ul class="good-detail-introduce-list">
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin查重报告
                    </li>
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin AI检测报告
                    </li>
                    <li class="good-detail-introduce-bold">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        额外赠送2次Tūrnitin AI内容高亮定位（联系客服获取）
                    </li>
                </ul>
            </el-card>
            <el-card class="good-detail" shadow="never">
                <h2 class="good-detail-title">20次</h2>
                <p class="good-detail-info">
                    <span class="currency-type">¥ </span>
                    <span class="goods-price">{{ goodListPrice[4] }}</span>
                </p>
                <el-button
                    class="buy-now"
                    round
                    style="width: 100%; font-size: 20px"
                    type="danger"
                    @click="doRecharge(300005, goodListPrice[4], '套餐五_300005')"
                >
                    立即购买
                </el-button>
                <ul class="good-detail-introduce-list">
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin查重报告
                    </li>
                    <li class="good-detail-introduce">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        Tūrnitin AI检测报告
                    </li>
                    <li class="good-detail-introduce-bold">
                        <el-icon color="#409efc">
                            <Promotion />
                        </el-icon>
                        额外赠送2次Tūrnitin AI内容高亮定位（联系客服获取）
                    </li>
                </ul>
            </el-card>
            <el-dialog
                v-model="qrcodeVisible"
                :show-close="false"
                :style="{ height: qrcodeSize }"
                :width="qrcodeSize - 15"
                center
                class="qrcode-dialog"
                draggable
            >
                <el-image
                    :fit="'fill'"
                    :src="customerServiceUrl"
                    class="custom-service-qrcode"
                    style="width: 300px; height: 300px"
                    visiable="false"
                />
            </el-dialog>
        </div>
        <div class="goods-remind">
            <el-dialog
                v-model="goodsReminder"
                title="如未弹出支付窗口，请按以下步骤启用弹窗："
                width="500"
                draggable
                destroy-on-close
            >
                <p>1. 在浏览器地址栏的右侧或左侧寻找“弹窗已被阻止”的提示信息。</p>
                <p>2. 点击提示，并选择“允许弹窗”。</p>
                <p>3. 刷新页面以确保设置生效。</p>
                <template #footer>
                    <div class="dialog-footer">
                        <el-button type="primary" @click="goodsReminder = false"> 确认 </el-button>
                    </div>
                </template>
            </el-dialog>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue'
import { Promotion } from '@element-plus/icons-vue'
import { apiService } from '@/api/Api.js'
import { alertService } from '@/utils/alertService.js'
import customerServiceUrl from '@/assets/WechatIMG17.jpg'
import { removeToken } from '@/stores/authStore'

const qrcodeVisible = ref(false)
const qrcodeSize = 350
// const goodListPrice = [5.99, 28, 55, 260, 499, 998]
const goodListPrice = [5.99, 15.99, 24.99, 48.99, 94.99]
const goodsReminder = ref(false)

async function doRecharge(productId, rechargeAmount, subject) {
    goodsReminder.value = true
    const requestParams = {
        productId: productId,
        totalAmount: String(rechargeAmount),
        subject: subject
    }
    try {
        const response = await apiService.purchasePlagiarismCount(requestParams)
        const url = response.data.paymentUrl
        // 使用window.open方法在新窗口中打开url
        window.open(url, '_blank')
    } catch (error) {
        if (error.response?.data?.code === 401) {
            removeToken()
            alertService.showError('用户未登录')
            // router.push('/login')
        } else {
            alertService.showError(error.response?.data?.message || '发生未知错误！')
        }
    }
}
</script>
<style lang="scss">
.good-list-container {
    display: flex;
    width: 100%;
    min-height: 450px;
    flex-direction: column;
    padding-bottom: 40px;

    .activity-column {
        padding: 0 2% 0 2%;
        width: 100%;
        background-color: #ffffff; /* 背景颜色 */
        flex-direction: column; /* 修改为列方向布局 */
        margin-bottom: 20px;

        //.el-carousel__button {
        //    background-color: #ff9900;
        //}
        .el-carousel__ .tip-content {
            font-size: 16px;
            color: #e70b37; /* 字体颜色 */
        }

        .activity-container {
            display: flex;
            flex-direction: column;
            align-items: center;

            .activity-main {
                display: flex;
                flex-direction: column;

                .activity-content {
                    font-size: 16px;
                    color: #995700; /* 字体颜色 */
                    text-align: left;
                }
            }
        }

        //
        //.highlight {
        //    font-weight: bold;
        //    color: #ff6f00; /* 高亮颜色 */
        //}
    }

    .why-choose-us-section {
        padding: 20px 2%;
        width: 100%;
        background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        margin-bottom: 20px;
        border-radius: 12px;

        .why-choose-us-container {
            max-width: 1200px;
            margin: 0 auto;

            .why-choose-us-title {
                text-align: center;
                font-size: 24px;
                font-weight: bold;
                color: #2c3e50;
                margin-bottom: 20px;
                letter-spacing: 1px;
            }

            .why-choose-us-content {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                gap: 15px;

                .feature-item {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    background: rgba(255, 255, 255, 0.9);
                    border-radius: 8px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    transition:
                        transform 0.3s ease,
                        box-shadow 0.3s ease;

                    &:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
                    }

                    .el-icon {
                        margin-right: 12px;
                        font-size: 18px;
                        flex-shrink: 0;
                    }

                    .feature-text {
                        font-size: 15px;
                        color: #34495e;
                        line-height: 1.5;
                        font-weight: 500;
                    }
                }
            }
        }
    }

    .goods-list {
        width: 100%;
        display: flex;
        flex-direction: row;
        height: 450px;

        .good-detail {
            flex: 1;
            margin-left: 3px;
            margin-right: 3px;
            display: flex;
            flex-direction: column;

            .el-card__body {
                height: 100%;
                display: flex;
                flex-direction: column;
                padding: 20px;
            }

            .good-detail-feature {
                display: inline-block;
                background-color: rgba(255, 99, 71, 0.1);
                color: #ff6347;
                padding: 5px 15px;
                border-radius: 20px;
                font-size: 14px;
                font-weight: bold;
            }

            .good-detail-info {
                .currency-type {
                    font-size: 14px;
                    color: #ff614f;
                    font-weight: bold;
                }

                .goods-price {
                    font-size: 20px;
                    color: #ff614f;
                    font-weight: bold;
                }
            }

            .good-detail-introduce-list {
                padding-left: 0;
                padding-right: 0;
                // overflow-y: auto;
                flex: 1;
                margin-top: 15px;
                height: 250px;

                .good-detail-introduce,
                .good-detail-introduce-bold {
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;
                    font-size: 14px;
                    letter-spacing: 1px;
                    font-family: '微软雅黑';

                    .el-icon {
                        margin-right: 10px;
                    }
                }
            }

            .good-detail-introduce-bold {
                font-weight: bold;
            }

            .buy-now:disabled {
                background-color: var(--el-color-danger);
            }
        }
    }
}
</style>
